/**
 * Names later packages agreed on before their code exists (FINISH_PLAN WP0.6), so parallel work can reference them.
 * The save section names live with the save (`@highmarch/app` SAVE_SECTION_NAMES), the Guide topic ids with the guide
 * (ui/guide/guide.ts FeatureTopicId), the real-money store port with the app (`@highmarch/app` Store, packages/app/src/store.ts).
 */

/**
 * The painted 2D icons WP12 draws for the new features (`art/interface/icons/<name>.png`, loaded with ui/portraits.ts
 * `uiUrl`). Until a file lands, a feature draws the nearest kit SVG (ui/iconsKit.ts) instead.
 */
export const FEATURE_ICON_PATHS = {
  gem: "icons/gem.png",
  marks: "icons/marks.png",
  crate: "icons/crate.png",
  merchant: "icons/merchant.png",
  eventEmber: "icons/event_ember.png",
  achievement: "icons/achievement.png",
} as const;

/**
 * `ui/legalSheet.ts` (WP4) exports `showLegal` with this shape: About & credits (credits, licences, the privacy link), as a
 * hub sheet appended to `parent` (class `legal`); returns the sheet.
 */
export type ShowLegal = (parent: HTMLElement) => HTMLElement;

/**
 * `infra/diagnostics.ts` (WP4) exports `copyDiagnostics` with this shape: the build, the device and the local error
 * ring buffer as text, out through the share sheet or the clipboard, like Settings → Save backup.
 */
export type CopyDiagnostics = () => Promise<"shared" | "copied" | "failed">;
